import TitleScreenCrud from './TitleScreenCrud';

export default TitleScreenCrud;
